import axios from "axios";

export const saveInAws = (data: any, file: File) => {
    const postData = new FormData()
    for (const key in data.fields)
        postData.append(key, data.fields[key])
    postData.append('file', file)
    return axios.post(data.url, postData)
}